import { makeStyles } from '@material-ui/core';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles({
  Root: ({ selectStyles }) => {
    return {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #cad8ff',
        borderRadius: '10px'
      },
      '& .MuiSelect-select': {
        background: 'white !important',
        borderRadius: '10px',
        padding: '14px 32px 14px 14px'
      },
      // '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      //   border: '1px solid #cad8ff',
      //   borderRadius: '10px'
      // },
      // '&:hover .MuiOutlinedInput-notchedOutline': {
      //   borderColor: '#cad8ff'
      // },
      fontFamily: 'Poppins',
      fontSize: '12px',
      width: '100%',
      ...selectStyles
    };
  },
  paper: {
    '& .MuiMenu-list': {
      padding: '0'
    },
    '& .MuiMenuItem-root': {
      display: 'block',
      fontFamily: 'Poppins',
      fontSize: '14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    '& .MuiMenuItem-root.Mui-selected': {
      fontWeight: 'bold'
    },
    border: '1px solid #cad8ff',
    borderRadius: '0px 0px 14px 14px',
    marginTop: '5px',
    maxHeight: '256px',
    width: (props) => props.menuStyles.width || 'auto'
  }
});

const DefaultSelect = ({
  onSelect,
  value,
  renderValue = () => {},
  selectStyles = {},
  menuStyles = {},
  children,
  defaultValue = ''
}) => {
  const classes = useStyles({ menuStyles, selectStyles });

  return (
    <Select
      className={classes.Root}
      defaultValue={defaultValue}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
      MenuProps={{
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        classes: { paper: classes.paper },
        getContentAnchorEl: null,
        transformOrigin: {
          horizontal: 'left',
          vertical: 'top'
        }
      }}
      onChange={(e) => onSelect(e.target.value)}
      renderValue={renderValue}
      value={value}
      variant="outlined"
    >
      {children}
    </Select>
  );
};

export default DefaultSelect;
